import { makeDynamicConfigWidgets } from '~/helper/makeDynamicConfigWidgets';

export const cockpitActivitiesWidgets = makeDynamicConfigWidgets([
  {
    name: 'cockpitActivitiesDetail',
    cols: 12,
    props: {
      title: 'cockpit_activities_detail_widget_title',
      infoText: 'cockpit_activities_detail_widget_info_text',
    },
  },
]);
